export default __webpack_public_path__ + "static/media/home_icon.73e01571.svg";